/**
 * Navigation Utilities
 */
import {NavItem, SocialLink} from "@/@types";
import {SiFacebook, SiInstagram, SiYoutube} from "@icons-pack/react-simple-icons";
import {Mail, Ticket} from "lucide-react";


export const BOX_OFFICE_URL = 'https://www.tickettailor.com/events/acquiredtastecomedy'


/**
 * Format the main boxoffice link
 * @param ref
 */
export const formatBoxOfficeLink = (ref?: string): string => {
    let result = BOX_OFFICE_URL;
    if (ref?.length) {
        result += `?ref=${ref}`
    }
    return result;
}

// TODO: manage this links in a CMS ?
export const LinkService = {
    /**
     * Links for the single page app
     */
    getLandingNavLinks: (): NavItem[] => [
        {
            title: 'Events',
            slug: 'events'
        },
        {
            title: 'About',
            slug: 'about'
        },
        {
            title: 'Contact',
            slug: 'contact'
        },
    ],
    getNavLinks: (): NavItem[] => [], // Empty for non-landing pages, per original logic

    getSocialLinks: (): SocialLink[] => [
        {title: 'Tickets', slug: formatBoxOfficeLink('website'), icon: Ticket,},
        {
            title: 'Instagram',
            slug: 'https://instagram.com/acquiredtastecomedy',
            icon: SiInstagram,
            desktopVisible: true
        },
        {title: 'YouTube', slug: 'https://youtube.com/@acquiredtastecomedy', icon: SiYoutube},
        {title: 'Facebook', slug: 'https://facebook.com/acquiredtastecomedy', icon: SiFacebook},
        // TODO: make email icon a scroll-to the contact section ?
        {title: 'Email', slug: 'mailto:atc@acquiredtastecomedy.com', icon: Mail, desktopVisible: true},
    ],
};
